import { Validators } from "@angular/forms";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormComponentParams,
  IHardFormField,
  IHardFormFieldParams,
} from "@hardcode-kz/ui";
import { IMenuModel } from "@models/core/menu";
import { AdministrationEndpoints } from "@dmms/shared/data-access/administration/types/administration-endpoints";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { UIMenuItemsComponent } from "@app/shared/ui-kit/components/forms/ui-form/ui-custom-components/ui-menu-items/ui-menu-items/ui-menu-items.component";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";

export class MenuConfig implements IBaseConfig {
  version = 1;
  dicType = AdministrationEndpoints.Menu;
  showRestore = true;

  fields: IHardFormField[] = [
    {
      name: "id",
    },
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU],
        ),
      },
    },
    {
      name: "slug",
      type: HardFormFieldTypeEnum.Input,
      title: "dicTable.code",
      params: {
        validators: [Validators.required],
      },
    },
    {
      type: HardFormFieldTypeEnum.Component,
      params: {
        component: UIMenuItemsComponent,
      } as IHardFormComponentParams,
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IMenuModel[]> = {
    showDefaultActions: true,
    tableColumns: "44px repeat(2, 1fr) auto",
    columns: [
      {
        title: "№",
        name: "id",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.code",
        name: "slug",
        type: HardTableColumnTypeEnum.Text,
      },
    ],
  };
}
